module.exports = __webpack_public_path__ + "static/media/trash.09cf8edc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/trash.svg
// module id = 144
// module chunks = 0